<template>
  <div class="mb-2">
    <v-card outlined class="mb-2 pa-2" color="blue-grey lighten-5">
      <v-card-text class="py-2">
        <div class="caption text--secondary">
          <strong>Image Requirements:</strong><br />
          <strong>Width:</strong> {{ currentRequirements.width }}<br />
          <strong>Height:</strong> {{ currentRequirements.height }}<br />
          <strong v-if="currentRequirements.aspectRatio">Aspect Ratio:</strong> <span v-if="currentRequirements.aspectRatio">{{ currentRequirements.aspectRatio }}</span
          ><br v-if="currentRequirements.aspectRatio" />
          <strong v-if="currentRequirements.safeArea">Safe Area (for image content):</strong> <span v-if="currentRequirements.safeArea">{{ currentRequirements.safeArea }}</span
          ><br v-if="currentRequirements.safeArea" />
          <strong>Notes:</strong> {{ currentRequirements.notes }}
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "ImageRequirements",
  props: {
    type: {
      type: String,
      default: "offer",
      validator: function(value) {
        return ["offer", "package", "plan-category", "meal", "product", "dietitian", "custom"].indexOf(value) !== -1;
      },
    },
    width: {
      type: String,
      default: "",
    },
    height: {
      type: String,
      default: "",
    },
    aspectRatio: {
      type: String,
      default: "",
    },
    safeArea: {
      type: String,
      default: "",
    },
    notes: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      requirementsConfig: {
        offer: {
          width: "Max 400 px — scales down for smaller screens",
          height: "174 px",
          aspectRatio: "",
          safeArea: "",
          notes: "Responsive width — maintains height of 174 px, width shrinks on devices narrower than 400 px.",
        },
        package: {
          width: "300 px",
          height: "112 px",
          aspectRatio: "~2.68 (when width is 300 px)",
          safeArea: "Avoid placing key visual elements in Left side: 85–105 px reserved for overlay text/status",
          notes: "For active plan only card, width may increase on larger devices (wide phones), while height remains fixed at 112 px",
        },
        "plan-category": {
          width: "72 px",
          height: "72 px",
          aspectRatio: "1.0 (square)",
          safeArea: "",
          notes: "Square card used for plan categories.",
        },
        meal: {
          width: "110 px",
          height: "150 px",
          aspectRatio: "",
          safeArea: "No reserved overlay gap — image can be fully filled with the subject",
          notes: "No reserved overlay gap — image can be fully filled with the subject.",
        },
        product: {
          width: "~229 px",
          height: "168 px",
          aspectRatio: "~1.36",
          safeArea: "No reserved gap; image fills the card area",
          notes: "Image fills the entire card area without any reserved overlay space.",
        },
        dietitian: {
          width: "Max 300 px (scales down for smaller devices)",
          height: "Max 300 px (scales down for smaller devices)",
          aspectRatio: "1.0 (square)",
          safeArea: "",
          notes: "Square profile image that scales responsively for different device sizes.",
        },
      },
    };
  },
  computed: {
    currentRequirements() {
      if (this.type === "custom") {
        return {
          width: this.width,
          height: this.height,
          aspectRatio: this.aspectRatio,
          safeArea: this.safeArea,
          notes: this.notes,
        };
      }
      return this.requirementsConfig[this.type] || this.requirementsConfig.offer;
    },
  },
};
</script>
